import { Logo } from "./Logo";
import { PHONE_DISPLAY, telLink, whatsappLink, EMAIL, ADDRESS } from "@/lib/whatsapp";
import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";

const QUICK = ["home", "about", "services", "fleet", "packages", "gallery", "reviews", "faq", "contact"];

export default function Footer() {
  return (
    <footer className="bg-brand-blue text-white pt-20 pb-8" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Logo variant="light" size={90} />
            <p className="mt-6 text-white/80 text-sm leading-relaxed max-w-sm">
              Mamta Tours & Travels — a decade of trusted rides across Rajasthan. Local taxi, airport transfer, outstation cabs, tempo travellers & hand-crafted tour packages.
            </p>
            <div className="mt-6 flex items-center gap-2">
              {[Facebook, Instagram, Twitter, Youtube].map((I, i) => (
                <a key={i} href="#" aria-label="Social" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-orange flex items-center justify-center transition-colors">
                  <I className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] tracking-[0.28em] uppercase font-semibold text-white/60">Quick Links</div>
            <ul className="mt-4 space-y-2 text-sm">
              {QUICK.map((q) => (
                <li key={q}><a href={`#${q}`} className="text-white/80 hover:text-brand-orange transition-colors capitalize">{q}</a></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.28em] uppercase font-semibold text-white/60">Services</div>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              <li>Local Taxi Jodhpur</li>
              <li>Airport Transfer</li>
              <li>Outstation Taxi</li>
              <li>Tempo Traveller</li>
              <li>Luxury Car Rental</li>
              <li>Rajasthan Tour Packages</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.28em] uppercase font-semibold text-white/60">Contact</div>
            <ul className="mt-4 space-y-3 text-sm">
              <li><a href={telLink()} className="hover:text-brand-orange transition-colors">{PHONE_DISPLAY}</a></li>
              <li><a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="hover:text-brand-orange transition-colors">WhatsApp: {PHONE_DISPLAY}</a></li>
              <li><a href={`mailto:${EMAIL}`} className="hover:text-brand-orange transition-colors">{EMAIL}</a></li>
              <li className="text-white/70 leading-relaxed">{ADDRESS}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/15 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-xs text-white/70">© {new Date().getFullYear()} Mamta Tours & Travels · Your Journey, Our Priority</div>
          <div className="text-[10px] tracking-[0.28em] uppercase text-white/60">Jodhpur · Rajasthan · India</div>
        </div>
      </div>
    </footer>
  );
}
